import i18n from '@/localization/i18n'

i18n.setLocaleMessage('de', {
  ...i18n.messages.de,
  ...{
    app: {
      logout: {
        title: 'Abmelden',
        confirm: 'Möchten Sie sich wirklich abmelden?',
        'btn-ok': 'Abmelden',
        'btn-cancel': 'Abbrechen',
      },
      main: {
        title: 'Willkommen',
        button: {
          animal: 'Tier',
          report: 'Melden',
          company: 'Betrieb',
          deliveries: {
            piglet: 'Lieferscheine Ferkel',
            pigsty: 'Lieferscheine Mast',
          },
          reports: 'Auswertungen',
          protocols: 'Protokolle',
        }
      },
      login: {
        title: 'Anmelden',
        message: 'Melden Sie sich mit Ihren Account an',
        username: 'Benutzername',
        password: 'Passwort',
        button: 'Anmelden',
      },
      delivery: {
        title: 'Lieferschein|Lieferscheine',
        notify: {
          saved: {
            type: 'success',
            title: 'Gespeichert',
            message: 'Erfolgreich gespeichert'
          }
        }
      }
    }
  }
})

export default i18n
